import styled from 'styled-components';
import Alert from '@mui/material/Alert';

export const StyledAlert = styled(Alert)`
	padding: 2px 8px !important;
	width: max-content;
`;
